import unfetch from 'unfetch';

// Rollback switch for the change below: `sessionStorage.setItem('use_unfetch', 'true')`.
const isUnfetchForced = () => {
  try {
    return window.sessionStorage.getItem('use_unfetch') === 'true';
  } catch {
    return false;
  }
};

const legacyUnfetchRouting = nativeFetch => (url, options) => {
  const wantsBinary = options?.headers?.Accept === 'application/pdf';
  const useUnfetch =
    !wantsBinary && (url.startsWith('https://api.nbx.com/') || url.startsWith('https://localhost'));
  return useUnfetch ? unfetch(url, options) : nativeFetch(url, options);
};

/* unfetch replaced native fetch on every api.nbx.com call, but its XHR rejects with a DOM event
instead of an Error and never settles on timeout. It is a polyfill again. */
export const patchWebFetch = nativeFetch => {
  if (typeof nativeFetch !== 'function') return unfetch;
  return isUnfetchForced() ? legacyUnfetchRouting(nativeFetch) : nativeFetch;
};
